"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Possible cell period types
// i.e., summary monthly cells are a period of a day while summary daily cells are a period of an hour.
const periodTypes = Object.freeze({
    HOUR: "hour",
    DAY: "day",
});
exports.default = periodTypes;
